import React, { useCallback, useState } from 'react';
import P from 'prop-types';
import { InputText } from '../InputText';
import { Button } from '../Button';
import { toast } from 'react-toastify';
import { FormataValor } from '../../utils/utils';

export const FinalizacaoTroco = ({ param }) => {
  const [value, setValue] = useState(param.troco);

  const handleChange = useCallback((event, value) => {
    event.preventDefault();
    setValue(value);
  }, []);

  const handleClick = useCallback(
    (value) => {
      if (value > param.total || value == 0) {
        param.setTroco(value);
        param.showHideModalTroco();
        return;
      }
      toast.error('Troco deve ser superior a ' + FormataValor(param.total), {
        autoClose: 2500,
      });
    },
    [param],
  );

  return (
    <div style={{ margin: '20px 40px 30px', textAlign: 'center' }}>
      <p style={{ paddingBottom: '20px', textAlign: 'center', fontSize: '1.125rem', fontWeight: 600 }}>
        Precisa de Troco ?
      </p>
      {/* <p style={{ float: 'left', position: 'absolute', margin: '8px 15px' }}>R$</p> */}
      <InputText
        type={'currency'}
        className="form-control form-font-grande"
        value={value}
        onChange={handleChange}
        textAlign="center"
      />

      <div style={{ padding: '20px 0' }}>
        <Button
          icon="check"
          className="btn_1 btnGradientInverted full-width mb_5  "
          onClick={() => handleClick(value)}
          text="Confirmar"
          iconAlign="right"
        />
      </div>
    </div>
  );
};

FinalizacaoTroco.propTypes = {
  param: P.object,
};
